import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Container from 'partials/Container';
import AnimateIn from 'partials/AnimateIn';
import { h1Styles, h2Styles, h3Styles } from 'partials/typography';

import api from 'api';
import {connect} from 'react-redux';

class ImportantDates extends Component{

    constructor() {
        super();
        this.state = {
            mounted: false,
            sortedDates : []
        }
    }

    componentDidMount() {
        api.importantDatesFetcher.getAll();
        
    }

    // Sorted by Year, Month, Day
    // 1 event per day
    _sortDates(importantDates){
        if(importantDates.length > 0) {

            let sortedDates = {};

            importantDates
            .filter(item => {
                const date = item.acf.date.split(':');
                const itemMoment = moment(`${date[0]}-${date[1]}-${date[2]}`, 'D-M-YY');
                return moment().diff(itemMoment, 'days') <= 0;
            })
            .map(item => {
                const date = item.acf.date.split(':');
                // Is year set?                
                if(sortedDates[date[2]] === undefined) {
                    sortedDates[date[2]] = {};

                }
                // Is month set?
                if(sortedDates[date[2]][date[1]] === undefined) {

                    sortedDates[date[2]][date[1]] = {
                        month: date[3],
                        days: {
                            [date[0]] : {
                                event: item,
                                day: date[4],
                                month: date[3]
                            }
                        }
                    }
                } else {
                    sortedDates[date[2]][date[1]].days[date[0]] = {
                            event: item,
                            day: date[4],
                            month: date[3]
                        }
                }
                return true;

            });
            return sortedDates;
        }
        return false;
    }

    render()  {
        const { importantDates } = this.props;
        const sortedDates = this._sortDates(importantDates);
        const currentYear = new Date().getYear() - 100;

        if(!sortedDates) return null;

        let row = 0;
        
        //console.log("sortedDates",sortedDates, currentYear);

        return (
            <Wrapper>
                <AnimateIn>
                    <Container>
                        {Object.keys(sortedDates).map(yearNum => {
                            let showYearNum = currentYear === Number(yearNum) ? false : true;
                            return (
                                <YearWrapper key={yearNum}>
                                    {Object.keys(sortedDates[yearNum]).map(monthNum => {
                                        const month = sortedDates[yearNum][monthNum].month;
                                        row ++;
                                        return (
                                            <MonthWrapper key={monthNum} row={row}>
                                                {showYearNum && <div className="yearNum">20{yearNum}</div>}
                                                {showYearNum = false}
                                                <h3>{month}</h3>
                                                {Object.keys(sortedDates[yearNum][monthNum].days).map(dayNum => {
                                                    const day = sortedDates[yearNum][monthNum].days[dayNum];
                                                    return (
                                                        <DayWrapper key={dayNum}>
                                                            <h4>{day.day}</h4>
                                                            <div className="dateDay">{dayNum}</div>
                                                            <div className="eventTimes">
                                                                {day.event.acf.start_time}
                                                                {day.event.acf.end_time &&
                                                                    "-"+day.event.acf.end_time
                                                                }
                                                            </div>
                                                            <div className="day">{day.event.acf.description}</div>
                                                        </DayWrapper>
                                                    )
                                                })}
                                            </MonthWrapper>
                                        )
                                    })}
                                </YearWrapper>
                            )
                        })}
                    </Container>
                </AnimateIn>
            </Wrapper>
        );
    }
}
const mapStateToProps = state => ({
    importantDates: state.importantDates.posts,
});

export default connect(mapStateToProps)(ImportantDates);

const Wrapper = styled.article`
    padding-top:60px;
    margin-bottom:60px;
    @media (max-width: 767px) {
        margin-bottom:40px;
        padding-top:0;
    }
`

const YearWrapper = styled.div`
    
`
const MonthWrapper = styled.div`
    padding-top: 60px;    
    padding-bottom: 20px;
    @media(max-width: 767px) {
        padding-top: 30px;
        padding-bottom:0;
    }
    ${props => Number(props.row) % 2 === 0 ? `
        background-color: #F0DBDA;
        width: 150vw;
        padding-left: 50vw;
        transform: translateX(-50vw);        
    ` : ``}
    .yearNum {
        ${h1Styles}
        margin-bottom:100px;
    }
    h3{
        ${h2Styles}
        text-transform: capitalize;
        width: 100%;
        margin-bottom: 50px;
        @media(max-width: 767px) {
            margin-bottom:30px;
        }
    }
    display: flex;
    flex-wrap: wrap;
    
`

const DayWrapper = styled.div`    
    width: 25%;
    padding-right: 40px;
    margin-bottom: 40px;
    @media(max-width: 767px) {
        width:33.33%;
        margin-bottom: 30px;
    }
    @media(max-width: 480px) {
        width:50%;
        &:nth-child(odd) {
            padding-right: 0;
        }
    }
    @media(max-width: 400px) {
        width:100%;
        padding-right: 0;
    }
    h4 {
        ${h3Styles}
    }
    .dateDay{
        ${h1Styles}
        margin: 10px 0;
    }
    .eventTimes{
        ${h3Styles}
        margin-bottom: 10px;
    }
    
`


// WEBPACK FOOTER //
// ./src/partials/modules/ImportantDates.js